import { FormFieldListModel } from '@/model/FormModel'
// import { payTypeList } from '@/utils/index'

export const baseForm: FormFieldListModel[] = [
  {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'customerCompanyId',
    fieldName: '客户公司',
    placeholder: '',
    value: '',
    option: [],
    rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
    config: {
      isDisabled: false,
      clearable: true,
      url: 'customerCompany/dropdown',
      filterable: true,
      selectType: 2, // 1本地2远程
      remote: true
    }
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'customerCompanyContactId',
    fieldName: '客户联系人',
    placeholder: '',
    value: '',
    rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
    option: [],
    config: {
      collapseTags: true,
      isDisabled: false,
      multiple: false,
      clearable: true,
      url: 'customerCompanyContact/dropdown',
      pickerType: '',
      filterable: true,
      selectType: 2, // 1本地2远程
      remote: true,
      params: {
        companyId: ''
      }
    }
  },
  {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'type',
    fieldName: '类型',
    placeholder: '',
    value: 1,
    rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
    option: [],
    config: {
      collapseTags: false,
      isDisabled: false,
      multiple: false,
      clearable: true,
      url: 'BusinessFeeType',
      filterable: true,
      remote: false,
      selectType: 1// 1本地2远程
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    fieldName: '费用',
    placeholder: '',
    value: '',
    rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
    config: {
      isDisabled: false,
      clearable: true,
      url: '',
      filterable: false
    }
  },
  {
    componentType: 'el-select-obejct',
    componentName: '下拉选择',
    fieldKey: 'account',
    fieldName: '账户信息',
    placeholder: '',
    value: '',
    rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
    option: [],
    config: {
      isDisabled: false,
      multiple: false,
      clearable: true,
      uniqueFieldKey: 'companyConcatPayType',
      isHide: false,
      alias: 'alias',
      selectType: 3// 1本地2远程
    }
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'name',
  //   fieldName: '账户名',
  //   placeholder: '',
  //   value: '',
  //   rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
  //   config: {
  //     isDisabled: false,
  //     clearable: true,
  //     url: '',
  //     filterable: false,
  //     isHide: true,
  //     submitField: 'accounts'
  //   }
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'no',
  //   fieldName: '账号',
  //   placeholder: '',
  //   value: '',
  //   rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
  //   config: {
  //     isDisabled: false,
  //     clearable: true,
  //     url: '',
  //     filterable: false,
  //     isHide: true,
  //     submitField: 'accounts'
  //   }
  // }, {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'bank',
  //   fieldName: '开户行',
  //   placeholder: '',
  //   value: '',
  //   rules: [{ required: true, message: '', trigger: 'change' }],
  //   config: {
  //     isDisabled: false,
  //     clearable: true,
  //     url: '',
  //     filterable: false,
  //     isHide: true,
  //     submitField: 'accounts'
  //   }
  // },

  {
    componentType: 'el-textarea',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注',
    placeholder: '',
    value: '',
    rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
    config: {
      isDisabled: false,
      clearable: true,
      width: '100%'
    }
  }
]
